// Back button events processing.
$('.backButtonDetector').each(function () {
  window.onunload = function () {
  };

  if (backButtonClicked()) {
    // Here goes everything that should on back button click;
    $(document).ready(function () {
      $('#flash-message').hide();
    });
  }

  if (forvardButtonClicked()) {
    // Here goes everything that should on forvard button click;
    $(document).ready(function () {
      $('#flash-message').hide();
    });
  }

  // Back button detector.
  function backButtonClicked() {
    var check = false;
    if (pageUpdated()) {
      localStorage.setItem('nextUrl', false);
      setPreviousPage();
      localStorage.setItem('pageHistory', JSON.stringify([window.location.href]));
    }
    else {
      let history = JSON.parse(localStorage.getItem('pageHistory'));
      history.push(window.location.href);
      if (window.location.href === localStorage.getItem('previousUrl')) {
        check = true;

        let index = history.lastIndexOf(window.location.href);
        localStorage.setItem('nextUrl', history[index - 1]);
      }
      localStorage.setItem('pageHistory', JSON.stringify(history));
    }
    return check;
  }

  // Forvard button detector.
  function forvardButtonClicked() {
    var check = false;
    if (!pageUpdated()) {
      let history = JSON.parse(localStorage.getItem('pageHistory'));
      if (window.location.href === localStorage.getItem('nextUrl')) {
        check = true;
      }
    }
    return check;
  }

  // Page update detector.
  function pageUpdated() {
    let check = $('[name="backButtonCheck"]').prop('checked');
    if (!check) {
      $('[name="backButtonCheck"]').prop('checked', true);
    }
    return !check;
  }

  function setPreviousPage() {
    let history = localStorage.getItem('pageHistory');
    let hasHistory = false;
    if (history) {
      history = JSON.parse(history);
      history.reverse().forEach((link) => {
        if (link !== window.location.href && hasHistory === false) {
          localStorage.setItem('previousUrl', link);
          hasHistory = true;
        }
      });
    }
    if (!hasHistory) {
      localStorage.setItem('previousUrl', false);
    }
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/flash_message.js